module.exports = __webpack_public_path__ + "img/excedrin_extra_strength.78076a8f.png";